import isMaestro from "./isMaestro";
import isPlaywright from "./isPlaywright";

const isTestUser = isPlaywright || isMaestro;
export default isTestUser;
